import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetContactQuery } from "@/store/rest_api";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import ContactActivity from "@/components/contacts/ContactActivity";
import { PropertyDetailCard } from "@/components/pages/properties/PropertyDetailCard";
import LeadStagePanel from "@/components/deals/LeadStagePanel";

const LeadDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: lead } = useGetContactQuery(id!);
  const { setSection, setSectionPath, setPage } = useBreadcrumbs();

  useEffect(() => {
    setSection("Leads");
    setSectionPath("/leads");
  }, [setSection, setSectionPath]);

  useEffect(() => {
    if (lead) {
      setPage([lead.firstName, lead.lastName].filter(Boolean).join(" ") || "Lead");
    }
  }, [lead, setPage]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-auto">
        <ContactActivity contactId={id!} headerExtra={lead ? <LeadStagePanel contact={lead} /> : undefined} />
        {lead?.properties && lead.properties.length > 0 && (
          <div className="p-4 space-y-4">
            {lead.properties.map((property) => (
              <PropertyDetailCard key={property.id} property={property} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadDetailPage;
